module.exports = __webpack_public_path__ + "static/media/berriepelser.305ad482.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/berriepelser.webp
// module id = 629
// module chunks = 0